import { usePlayer } from "~/components/PlayerContext";
import rootStyles from "~/components/Root.module.scss";
import Tooltip from "~/components/Tooltip";
import styles from "~/components/player/PlayButton.module.scss";

const labels = {
  play: "Pause",
  pause: "Play",
  buffering: "Carregando...",
};

export default function PlayButton() {
  const player = usePlayer();

  const states = () => ({
    play: <IconTablerPlayerPauseFilled />,
    pause: <IconTablerPlayerPlayFilled />,
    buffering: <IconTablerLoader2 class={rootStyles.spin} />,
  });

  return (
    <Tooltip
      content={labels[player.state]}
      type="button"
      class={styles.button}
      aria-label={labels[player.state]}
      onClick={() => {
        void globalThis.window.jhplayer.toggle();

        for (const player of document
          .querySelector("#app")
          ?.querySelectorAll<HTMLMediaElement>("audio, video") ?? []) {
          player.pause();
        }
      }}
    >
      {states()[player.state]}
      <span class={rootStyles["sr-only"]}>{labels[player.state]}</span>
    </Tooltip>
  );
}
